export default __webpack_public_path__ + "static/media/how-we-help-1.25382de2.svg";